export default "__VITE_PUBLIC_ASSET__5f0ce9d6__"